/* eslint-disable import/prefer-default-export */

import Toast from '@/components/toast';
import Cashier from '@hb/h5-pay';
import { getTokenAndLocation, getTWCardPlatform } from '@/utils';
import config from '@/const/config';
import { twPreOrder } from '@/api/card';
import { Native, env } from '@hb/hbridge';
import * as HBridge from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getUserNickName } from '@/api/vip';
import { Navigator } from '@hb/h5-navigator';
import { ParamsUtil } from '@/utils/params';
import { safeJsonStringify } from '@/utils/tools';
import { getSystemCode } from '../utils/systemCode';
import { getTokenAndKey } from '../utils/index';

export const CardService = new (class {
  cashier = null;

  async initCashier(refer) {
    const { token } = await getTokenAndKey();
    if (!this.cashier || refer) {
      this.cashier = new Cashier({
        env: config.env,
        ubt: UBT,
        hbridge: HBridge,
        token,
        systemCode: getSystemCode(),
      });
    }
  }

  // v2
  async buy(data, {
    actionOrigin, shelfGuid, businessType, channelCode,
    returnUrl,
  } = {}, type) {
    if (!data) {
      return Promise.reject(new Error('未找到卡信息'));
    }

    this.initCashier(true);
    const {
      token, ticket, cityCode, adCode,
    } = await getTokenAndLocation();
    const {
      actualPrice, pendingInfos, packageGuid, paymentLimit,
    } = !type ? data : data.commodityPackageItemDTO;
    const toPost = {
      token,
      adCode,
      cityCode,
      ticket,
      platform: getTWCardPlatform(),
      bizContent: {
        businessType,
        totalPrice: actualPrice.finalPrice,
        cardInfoGuid: shelfGuid,
        channelCode: `${channelCode}`,
        // businessType: '',
        packageList: [
          {
            category: 1,
            packageGuid,
            pendingInfos,
            actualPrice,
          },
        ],
      },
    };
    try {
      const v = await twPreOrder(toPost);
      if (
        v.code === 0
        && v.data
        && v.data.orderGoPayList
        && v.data.orderGoPayList[0]
      ) {
        const { orderNo: orderId, payPrice, payNo } = v.data.orderGoPayList[0];
        const { businessType: biz, businessScene } = v.data;
        if (Number(paymentLimit) !== 1) {
          try {
            await this.cashier.pay({
              payParams: {
                businessType: biz, // 必填；业务线
                businessScene, // 必填；业务线支付场景
                adCode, // 非必填
                cityCode, // 非必填
                payList: [
                  {
                    // 必填；支持多笔订单支付
                    guid: payNo, // 必填；支付交易id
                    amount: `${payPrice}`, // 必填；支付金额
                    type: 1, // 非必填；默认是1； 1:待支付订单，2:零元订单,
                  },
                ],
              },
              token,
              returnUrl: returnUrl || window.location.href, // todo 支付之后的回调
              isNeedCancelCall: false,
            });
            if (returnUrl) {
              if (env.isAliMP || env.isAliMPMonitor || env.isEasyBikeApp) {
                window.location.href = returnUrl;
              }
            }
            return Promise.resolve();
          } catch (e) {
            Toast.showError(e);
            return Promise.reject(e);
          }
        } else {
          if (env.isWechatMini) {
            return Promise.reject(new Error('微信小程序暂不支持连续包月'));
          }
          const signInfo = {
            guid: payNo, // 必填；交易凭证号
            orderId, // 必填；订单id
            amount: `${payPrice}`, // 必填；支付金额
            businessType, // 必填；业务线
            signChannel: 'alipay', // 必填；免密签约渠道：alipay-支付宝
            creditModel: 'normal', // 必填；请求授信模式：normal: 普通模式，huazhi_allow_degrade：「花芝代扣」模式且允许降级（不能开通花呗的可以开通普通代扣模式）  ， huazhi_not_degrade：「花芝代扣」模式且不允许降级（不能开通花呗的用户不能开通）】
            actionOrigin, // 必填；动作行为来源：业务线唤起免密签约组件行为的页面来源，业务线产品经理向支付平台报备，分配参数值后传入
          };
          if (env.isEasyBikeApp) {
            Object.assign(signInfo, {
              orders: [
                {
                  guid: payNo,
                  orderId,
                  businessType,
                  amount: `${payPrice}`,
                  type: '1', // 1-待支付订单  0-0元订单
                },
              ],
            });
          } else {
            Object.assign(signInfo, {
              guid: payNo, // 必填；交易凭证号
              orderId, // 必填；订单id
            });
          }
          try {
            await Native.payWithSign(signInfo);
            return Promise.resolve();
          } catch (error) {
            Toast.showError(error);
            return Promise.reject(error);
          }
        }
      } else {
        Toast.show('购买失败');
        return Promise.reject();
      }
    } catch (error) {
      Toast.showError(error);
      return Promise.reject(error);
    }
  }

  async buyMember(data) {
    await this.initCashier(true);
    const {
      payNo,
      businessScene,
      businessType,
      price,
      orderNo,
    } = data;
    const {
      token, cityCode, adCode,
    } = await getTokenAndLocation();
    try {
      await this.cashier.pay({
        payParams: {
          businessType, // 必填；业务线
          businessScene, // 必填；业务线支付场景
          adCode, // 非必填
          cityCode, // 非必填
          payList: [
            {
              // 必填；支持多笔订单支付
              guid: payNo, // 必填；支付交易id
              amount: price, // 必填；支付金额
              type: 1, // 非必填；默认是1； 1:待支付订单，2:零元订单,
              orderId: orderNo,
            },
          ],
        },
        token,
        returnUrl: window.location.href, // todo 支付之后的回调
        isNeedCancelCall: false,
        extra: {
          wxMini: {
            returnUrl: `${window.location.href}&finishPay=1`,
          },
        },
      });
      // if (returnUrl) {
      //   if (env.isAliMP || env.isAliMPMonitor || env.isEasyBikeApp) {
      //     window.location.href = returnUrl;
      //   }
      // }
      return Promise.resolve();
    } catch (e) {
      Toast.showError(e);
      return Promise.reject(e);
    }
  }

  async buyContinueMember(data) {
    await this.initCashier(true);
    const {
      payNo,
      businessType,
      price,
      orderNo,
      signChannel,
      extension,
      channel,
      channelOperationInfoExt,
    } = data;
    try {
      const param = {
        guid: payNo, // 必填；交易凭证号
        orderId: orderNo, // 必填；订单id
        amount: price, // 必填；支付金额
        orders: [{
          guid: payNo,
          amount: price,
          businessType,
        }], // 该字段仅嵌入app 端需要
        businessType, // 必填；业务线
        signChannel: signChannel || 'alipay', // 必填；免密签约渠道：alipay-支付宝; wechatTrust：微信支付并签约(APP 最小支持版本 6.82.0);douyinTrust:抖音支付并签约(APP 最小支持版本 6.83.0)
        creditModel: 'normal', // 必填；请求授信模式：normal: 普通模式，huazhi_allow_degrade：「花芝代扣」模式且允许降级（不能开通花呗的可以开通普通代扣模式）  ， huazhi_not_degrade：「花芝代扣」模式且不允许降级（不能开通花呗的用户不能开通）】
        actionOrigin: 'PaidUpMember', // 必填；动作行为来源：业务线唤起免密签约组件行为的页面来源，业务线产品经理向支付平台报备，分配参数值后传入
        extension: extension || {},
      };
      // channel 2309为抖音签约
      if ((signChannel && !signChannel.includes('alipay')) || channel === '2309') {
        const nickName = await this.getNickName();
        param.extension.contractDisplayAccount = nickName;
      }
      if (channel === '2309' || channel === '2304') {
        param.channelOperationInfoExt = safeJsonStringify(channelOperationInfoExt);
        param.channel = channel;
        delete param.signChannel;
      }
      await this.cashier.payWithSign(param);
      return Promise.resolve();
    } catch (e) {
      Toast.showError(e);
      return Promise.reject(e);
    }
  }

  async payTiktokMoney(data) {
    await this.initCashier(true);
    const {
      signChannel,
      businessType,
      payMoney,
      payOrderId,
      orderId,
      bizScene,
      productTagForDySign,
      signMustPay,
      extension = {},
      channel,
    } = data;
    try {
      const param = {
        guid: payOrderId, // 必填；交易凭证号
        orderId, // 必填；订单id
        amount: payMoney, // 必填；支付金额
        orders: [{
          guid: payOrderId,
          amount: payMoney,
          businessType,
        }], // 该字段仅嵌入app 端需要
        businessType, // 必填；业务线
        signChannel: signChannel || 'alipay', // 必填；免密签约渠道：alipay-支付宝; wechatTrust：微信支付并签约(APP 最小支持版本 6.82.0);douyinTrust:抖音支付并签约(APP 最小支持版本 6.83.0)
        creditModel: 'normal', // 必填；请求授信模式：normal: 普通模式，huazhi_allow_degrade：「花芝代扣」模式且允许降级（不能开通花呗的可以开通普通代扣模式）  ， huazhi_not_degrade：「花芝代扣」模式且不允许降级（不能开通花呗的用户不能开通）】
        actionOrigin: 'Douyin1Cent', // 必填；动作行为来源：业务线唤起免密签约组件行为的页面来源，业务线产品经理向支付平台报备，分配参数值后传入
        extension: {
          signMustPay,
          ...extension,
        },
        channelOperationInfoExt: JSON.stringify({
          biz_scene: bizScene,
          productTagForDySign,
        }),
        ttMini: { // 抖音小程序相关特有配置项
          miniPayPath: '/pages/pay-platform/pay-with-sign/index', // 用于跳转微信小程序对应得支付并签约页面
          returnUrl: window.location.href, // 支持h5url，以及小程序原生页面，不传，则会以navigateBack的方式返回，防止页面刷新
          isRelaunch: 1, // 为1则表示支付成功之后需要relaunch的方式跳转
        },
      };
      if (channel) {
        param.channel = channel; // 和signChannel二选一，2039:抖音复合签约 -哈啰6.93.0支持
        delete param.signChannel;
      }
      // eslint-disable-next-line no-console
      console.log('payWithSign-param', JSON.stringify(param));
      await this.cashier.payWithSign(param);
      return Promise.resolve();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('payWithSign-error', e);
      Toast.showError(e);
      return Promise.reject(e);
    }
  }

  async signWithoutPasswordContract() {
    await this.initCashier(true);
    try {
      await this.cashier.signWithoutPasswordContract({
        businessType: 43,
        sceneType: 'HELLO_MEMBER',
        signChannel: 'alipay',
        actionOrigin: 'HELLO_MEMBER',
      });
      return Promise.resolve();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      Toast.showError(e);
      return Promise.reject(e);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getNickName() {
    const { token, cityCode } = await getTokenAndLocation();
    const res = await getUserNickName({ token, cityCode });
    return (res.data && res.data.nickName) || '';
  }

  async signWithoutPasswordContractTwo(params = {}) {
    if (!params || !Object.keys(params).length) {
      return Promise.reject(new Error('params参数不能为空'));
    }

    await this.initCashier(true);
    try {
      await this.cashier.signWithoutPasswordContract(params);
      return Promise.resolve();
    } catch (e) {
      Toast.showError(e);
      return Promise.reject(e);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async evokePageAndSign(data, planId) {
    const {
      payNo: guid, price: amount, businessType,
      loopIntervalSecond,
      orderNo,
      loopTotalSecond,
    } = data;
    const urlParam = {
      finishPay: '1',
      loopIntervalSecond,
      orderNo,
      loopTotalSecond,
    };
    let url = window.location.href;
    const removeArray = ['finishPay', 'loopIntervalSecond', 'orderNo', 'loopTotalSecond', 'isRenew'];
    removeArray.forEach((key) => {
      url = ParamsUtil.removeParams(url, key);
    });
    const addUrl = ParamsUtil.addParams(url, urlParam);
    const encodeUrl = encodeURIComponent(addUrl);
    const nickName = await this.getNickName();
    const payParam = {
      guid,
      amount,
      businessType,
      contractDisplayAccount: nickName,
      redirectUrl: encodeUrl,
      isRelaunch: '1',
      planId,
    };
    const basePath = '/pages/pay-plateform/pay-with-sign/index';
    const path = ParamsUtil.noEncodeAddParams(basePath, { ...payParam });
    Navigator.go(path);
  }
})();
